<script>
/**
 * The BottomPopup component acts as the customized action sheet
 * for the project usage as the standard component.
 *
 * Usage: 
 *  <bottom-popup
 *    :showPopup="showTeamOptions"
 *    :options="teamOptions"
 *    :title="title"
 *    :description="description"
 *    @select-option="onTeamOptionSelect"
 *    @close-popup="showTeamOptions = false">
 *  </bottom-popup>
 *  showPopup:Boolean - The display flag.
 *  options:Array - The popup options.
 *  title:String - The popup title.
 *  description - The description title.
 *  select-option:Event - Trigger the event after the option is selected.
 *  close-popup:Event - Trigger the event after the popup is closed.
 */

//--------------------------------------------------
// imported classes
//--------------------------------------------------
import { ActionSheet } from 'vant'

//--------------------------------------------------
// main script
//--------------------------------------------------
export default {
    //--------------------------------------------------
    // component name
    //--------------------------------------------------
    name: 'bottom-popup',

    //--------------------------------------------------
    // component components
    //--------------------------------------------------
    components: {
        'van-action-sheet': ActionSheet
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        /* The show popup status for the component */
        showPopup: {
            type: Boolean,
            default: false
        },
        /* The options for the popup */
       options: {
            type: Array
        },
        /* The title for the popup */
        title: {
            type: String
        },
        /* The description for the popup */
        description: {
            type: String
        }
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
    emits: [
        'select-option',
        'close-popup'
    ],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            /* The show status for the popup model */
            show: this.showPopup
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the isCloseOnClickAction status.
         */
        isCloseOnClickAction() {
            return true
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        //--------------------------------------------------
        // handler method
        //--------------------------------------------------
        /**
         * @handler
         * Handle the option select event.
         */
        onOptionSelect(item, index) {
            // console.log('onOptionSelect', item, index)
            this.$emit('select-option', item, index)
        }
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        /**
         * Watch the parent attribute to update the child property.
         */
        showPopup(value) {
            this.show = value
        }
    }
}
</script>

<template>
    <!-- component -->
    <div class="bottom-popup">
        <van-action-sheet
            v-model="show"
            :actions="options"
            @select="onOptionSelect"
            @click-overlay="$emit('close-popup')"
            :title="title"
            :close-on-click-action="isCloseOnClickAction">
            <template slot="default">
                <div class="popup-desc">{{ description }}</div>
            </template>
        </van-action-sheet>
    </div>
</template>

<style scoped>
/**
 * @component
 */
.bottom-popup .van-popup {
    background: #F9F9F9;
}
.bottom-popup .van-icon-cross:before {
    content: none;
}
.bottom-popup .van-action-sheet__header {
    margin-top: 8px;
    height: 65px;
    font-family: Source Han Sans;
    font-size: 17px;
    font-weight: 500;
    line-height: 31px;
    text-align: center;
    align-items: center;
    letter-spacing: 0.32px;
    color: #333333;
}
.bottom-popup .popup-desc {
    position: absolute;
    top: 44px;
    width: 100%;
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: normal;
    line-height: 22px;
    text-align: center;
    align-items: center;
    letter-spacing: 0.32px;
    color: #777777;
}
.bottom-popup .van-action-sheet__item {
    padding: 20px 16px 10px 16px;
    background: #F9F9F9;
    box-sizing: border-box;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #E5E5E5;
}
.bottom-popup .van-action-sheet__name {
    font-family: Source Han Sans;
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    letter-spacing: normal;
    color: #4D4D4D;
}
.bottom-popup .van-action-sheet__content {
    margin-bottom: 10px;
}
</style>